import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  DueDiligenceContextType,
  DueDiligenceDataType,
  DueDiligenceForGroupDataType,
  LocationState,
} from '../../core-utils/helper-utils/recommendedAppsHelper';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { MADueDiligenceModalProps } from '../../_components/organisms/MADueDiligenceModal';

export const DueDiligenceContext = createContext<
  DueDiligenceContextType | undefined
>(undefined);

export const DueDiligenceProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const location = useLocation();
  const { eg_nid } = location.state as LocationState;
  const abortController = new AbortController();

  const [loading, setLoading] = useState<boolean>(false);
  const [tableLoading, setTableLoading] = useState<boolean>(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState<boolean>(false);

  const [
    dueDiligenceData,
    setDueDiligenceData,
  ] = useState<DueDiligenceDataType>({
    company_name: '',
    date_created: '',
    documents_uploaded: [],
    parameters: [],
    status: 'Ready',
    type_of_plan: '',
    eg_nid: '',
  });
  const [dueDiligenceForGroupData, setDueDiligenceForGroupData] = useState<
    DueDiligenceForGroupDataType[]
  >([]);
  const [parameters, setParameters] = useState<string[]>([]);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [selectedParameters, setselectedParameters] = useState<string[]>([]);
  const [selectedConfidenceScore, setselectedConfidenceScore] = useState<
    string[]
  >([]);
  const [
    currentModalData,
    setCurrentModalData,
  ] = useState<MADueDiligenceModalProps>({
    parameter: '',
    subParameter: '',
    question: '',
    confidenceScore: '',
    answer: '',
    rationale: '',
    result: [],
  });

  const getDueDiligenceDetails = async () => {
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getDueDiligenceDetails,
        { eg_nid },
        { signal: abortController.signal },
      )
      .then((response) => {
        setDueDiligenceData(response.data?.data[0]);
        setParameters(response.data?.data[0]?.parameters);
      });
  };
  const getDueDiligenceForGroup = async (
    parameters: string[],
    confidenceScores: string[],
  ) => {
    setTableLoading(true);
    await axios
      .post(
        properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getDueDiligenceForGroup,
        { eg_nid, parameters, confidenceScores },
        { signal: abortController.signal },
      )
      .then((response) => {
        setDueDiligenceForGroupData(response.data?.data);
        setTableLoading(false);
      });
  };

  const apiCalls = async () => {
    setLoading(true);
    await Promise.allSettled([
      getDueDiligenceDetails(),
      getDueDiligenceForGroup([], []),
    ]).then(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    apiCalls();
    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <DueDiligenceContext.Provider
      value={{
        loading,
        tableLoading,
        dueDiligenceData,
        dueDiligenceForGroupData,
        parameters,
        selectedFilters,
        setSelectedFilters,
        selectedParameters,
        setselectedParameters,
        selectedConfidenceScore,
        setselectedConfidenceScore,
        getDueDiligenceForGroup,
        isDetailsModalOpen,
        setIsDetailsModalOpen,
        currentModalData,
        setCurrentModalData,
      }}
    >
      {children}
    </DueDiligenceContext.Provider>
  );
};

// Create a custom hook for safer consumption
export const useDueDiligenceContext = () => {
  const context = useContext(DueDiligenceContext);
  if (context === undefined) {
    throw new Error(
      'useDueDiligenceContext must be used within a DueDiligenceProvider',
    );
  }
  return context;
};
